export const Overlay = ({
  children,
  isOpen,
  onClick,
}: {
  children: React.ReactNode;
  isOpen: boolean;
  onClick: (e: React.MouseEvent) => void;
}) => (
  <div
    className={`fixed top-0 left-0 right-0 bottom-0 bg-black/50 justify-center items-end z-dropdown p-0 ${isOpen ? 'flex' : 'hidden'}`}
    style={{ animation: 'fade-in 0.2s ease-in-out' }}
    onClick={onClick}
  >
    {children}
  </div>
);

export const Container = ({ children, isOpen: _isOpen }: { children: React.ReactNode; isOpen: boolean }) => (
  <div
    className="w-full bg-white rounded-t-[26px] p-0 pb-16 relative max-h-[80dvh] h-auto flex flex-col overflow-hidden"
    style={{ animation: 'slide-from-bottom-full 0.3s ease-in-out' }}
  >
    {children}
  </div>
);

export const Header = ({ children }: { children: React.ReactNode }) => (
  <div className="flex justify-between items-center sticky top-0 bg-white z-10 p-4 pl-6 pr-6">{children}</div>
);

export const Title = ({ children }: { children: React.ReactNode }) => (
  <p className="text-[16px] font-medium text-[#2e2e2e] m-0">{children}</p>
);

export const CloseButton = ({ children, onClick }: { children: React.ReactNode; onClick: () => void }) => (
  <button
    className="bg-transparent text-[#6e6e6e] border-none p-0 cursor-pointer flex items-center justify-center"
    style={{ fontSize: '24px', lineHeight: '1' }}
    onClick={onClick}
  >
    {children}
  </button>
);

export const Content = ({ children, hasHeader }: { children: React.ReactNode; hasHeader?: boolean }) => (
  <div
    className="w-full overflow-y-auto flex-1"
    style={{
      padding: hasHeader ? '0 24px 24px 24px' : '40px 24px 80px 24px',
      WebkitOverflowScrolling: 'touch',
    }}
  >
    {children}
  </div>
);
